import React from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import Card from '../Card'
import routes from '../../config/routes'
import { HeroIcons } from '../../lib/utils/heroIcons'
import { PROMO_PROPERTY_ID } from '../../lib/utils/promo'

export default function PromoBanner() {
  const { t } = useTranslation('home')

  return (
    <Card className="relative overflow-hidden border border-amber-200/70 bg-gradient-to-r from-amber-50 via-white to-amber-50 px-5 py-4 shadow-sm">
      <div className="pointer-events-none absolute left-0 top-0 h-full w-1.5 bg-amber-400" />
      <div className="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-amber-200/60 blur-2xl" />
      <div className="pointer-events-none absolute -left-6 bottom-0 h-24 w-24 rounded-full bg-amber-100/80 blur-2xl" />
      <div className="relative flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3">
          <div className="rounded-xl bg-amber-100 p-2.5 text-amber-800">
            <HeroIcons.ReceiptPercentIcon
              className="h-5 w-5"
              aria-hidden="true"
            />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-amber-800">
              {t('yieldBoost.badge')}
            </p>
            <p className="text-sm font-semibold text-neutralBlack">
              {t('yieldBoost.title')}
            </p>
            <p className="mt-1 text-xs text-gray-600">
              {t('yieldBoost.subtitle')}
            </p>
          </div>
        </div>
        <div className="text-center">
          <Link
            href={{
              pathname: routes.property.replace(
                '[propertyId]',
                PROMO_PROPERTY_ID,
              ),
            }}
            className="inline-flex items-center justify-center rounded-full bg-neutralBlack px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-neutralBlack/90"
          >
            {t('yieldBoost.cta')}
          </Link>
        </div>
      </div>
    </Card>
  )
}
